import { render, staticRenderFns } from "./Piao4.vue?vue&type=template&id=a51ab3c4&"
import script from "./Piao4.vue?vue&type=script&lang=js&"
export * from "./Piao4.vue?vue&type=script&lang=js&"
import style0 from "./Piao4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports